import * as React from "react";
import { useCallback, useMemo } from "react";
import { gql, useQuery } from "@apollo/client";
import { Select, SelectProps } from "@stenajs-webui/select";
import { NegotiationStatusByYear } from "@/features/product-and-price/customers/customer-list/types";
import { NegotiationStatusSelectQuery } from "@/gql/graphql";

interface Props extends Omit<SelectProps<any>, "value" | "onChange"> {
  value?: NegotiationStatusByYear;
  onValueChange?: (value: NegotiationStatusByYear | undefined) => void;
}

const query = gql`
  query NegotiationStatusSelect {
    productPrice {
      negotiationStatus {
        all {
          id
          code
          name
          presentationOrder
        }
      }
    }
  }
`;

export const NegotiationStatusSelect: React.FC<Props> = ({
  onValueChange,
  value,
  ...selectProps
}) => {
  const { data, loading } = useQuery<NegotiationStatusSelectQuery>(query);
  const all = useMemo(() => {
    return data?.productPrice.negotiationStatus.all ?? [];
  }, [data]);

  const options = useMemo(() => {
    return all.map((s) => ({
      label: s.name,
      value: s.id,
    }));
  }, [all]);

  const selected = useMemo(
    () => options.find((o) => o.value === value?.id),
    [options, value]
  );

  const onValueChangeHandler = useCallback(
    (item: any) => {
      if (onValueChange) {
        const selectedNegStatus = all?.find((o) => o.id === item.value);
        onValueChange(selectedNegStatus);
      }
    },
    [all, onValueChange]
  );

  return (
    <Select
      {...selectProps}
      isLoading={loading}
      options={options}
      value={selected}
      onChange={onValueChangeHandler}
    />
  );
};
